import { RADIO_CONST } from './Radio.d';
import { Radio } from './Radio.styles';
import type { RadioProps } from './Radio.d';

const RadioBase = ({
  children,
  className,
  disabled,
  id,
  name,
  onChange,
  selectedValue,
  size,
  value,
  ...rest
}: RadioProps) => {
  const isChecked = selectedValue === value;

  return (
    <Radio.Label
      className={className}
      data-checked={isChecked}
      data-disabled={disabled}
      data-size={size}
      htmlFor={id}
    >
      <Radio.Input
        checked={isChecked}
        data-testid={RADIO_CONST.TEST_ID}
        disabled={disabled}
        id={id}
        name={name}
        onChange={(event) => onChange?.(event.target?.value)}
        type="radio"
        value={value}
        {...rest}
      />
      {children}
    </Radio.Label>
  );
};
export default RadioBase;
